import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=0d93eb4e&scoped=true"
import script from "./Mailing.vue?vue&type=script&lang=js"
export * from "./Mailing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d93eb4e",
  null
  
)

export default component.exports